// --------------------- Import Antd-Design ---------------------
import { Modal, Card, Skeleton, Divider } from "antd";
// --------------------- Import Styles ---------------------
import {
  ContainerModal,
  ItemTextModal,
  ItemWrapper,
  TextModal,
  Title,
} from "../styles";
// --------------------- Import Hooks ---------------------
import { useInteressadoAnuncio } from "../hooks/useInteressadoAnucio";
import { useAnuncioPropriedade } from "../hooks/useAnuncioPropriedade";
import { useVisualizacao } from "../hooks/useVisualizacao";
import { formatDate } from "../../../uteis/dateUtils";

export default function ModalAnuncio({
  isModalOpen,
  handleFechar,
  usuarioId,
  cotaUsuarioId,
}: any) {
  const { anuncioPropriedade, loading: isLoadinAnuncio } =
    useAnuncioPropriedade(cotaUsuarioId, isModalOpen);
  const { interessadoAnuncio, loading: isLoadingInteressado } =
    useInteressadoAnuncio(usuarioId, isModalOpen);

  const { visualizacoes, loading: isLoadingVisualizacoes } = useVisualizacao(
    anuncioPropriedade?.id
  );
  return (
    <>
      <Modal open={isModalOpen} onCancel={handleFechar} footer={null}>
        {isLoadingInteressado && isLoadinAnuncio && isLoadingVisualizacoes && (
          <Skeleton active />
        )}
        {!isLoadingInteressado &&
          !isLoadinAnuncio &&
          !isLoadingVisualizacoes && (
            <Card
              title={<Title>Anúncio</Title>}
              style={{
                width: "100%",
                marginTop: "20px",
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <ContainerModal>
                {[
                  {
                    label: "Data Início",
                    value: formatDate(anuncioPropriedade?.dataAnuncio),
                  },
                  {
                    label: "Data Inativação",
                    value: formatDate(
                      anuncioPropriedade?.dataInativacaoAnuncio
                    ),
                  },
                  {
                    label: "Quantidade de Visualizações",
                    value: visualizacoes,
                  },
                  {
                    label: "Quantidade de Cliques de Contato",
                    value: interessadoAnuncio,
                  },
                ].map((item, index) => (
                  <ItemWrapper key={index}>
                    <ItemTextModal>{item.label}</ItemTextModal>
                    <TextModal>{item.value}</TextModal>
                    {index < 8 && <Divider />}
                  </ItemWrapper>
                ))}
              </ContainerModal>
            </Card>
          )}
      </Modal>
    </>
  );
}
